<script setup lang="ts">
import UiText from './UiText.vue'
import UiDivider from './UiDivider.vue'

export interface UiFormSectionHeadingProps {
  text: string
  subtitle?: string
  divider?: boolean
}

const props = withDefaults(defineProps<UiFormSectionHeadingProps>(), {
  divider: false,
})
</script>

<template>
  <UiText v-if="props.text" as="h3" variant="h6" :text="props.text" class="font-semibold" />
  <UiText v-if="props.subtitle" as="p" variant="h6" :text="props.subtitle" class="text-gray-500" :class="props.text ? 'mt-1' : ''" />
  <UiDivider v-if="props.divider" spacing="xs" class="-mb-2" />
</template>


